import type { OnResizeOptions } from "@suse-o11y/on-resize";
import { useOnResize } from "@suse-o11y/use-on-resize";
import { useState } from "react";

export type UseResizeObserverOptions = Pick<OnResizeOptions<unknown>, "debounce">;

export function useResizeObserver<TElement extends HTMLElement>(
	element: null | undefined | TElement,
	{ debounce }: UseResizeObserverOptions = {},
): null | DOMRectReadOnly {
	const [rect, setRect] = useState<null | DOMRectReadOnly>(null);

	useOnResize((_, { contentRect }) => setRect(contentRect), {
		node: element,
		debounce,
	});

	return rect;
}
